<template>
    <div :class="$style['radio-table-message']">
        <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" :class="$style['table-data-label']" ref="tablePage" :pager-count="5">
            <wt-table :list="list" :labels="tableLabels" @select="select" ref="table">
                <template slot="before">
                    <el-table-column width="50">
                        <template slot-scope="scope">
                            <el-radio v-model="selectIndex" :label="subOnlyFiled ? scope.row[subOnlyFiled][onlyFiled] : scope.row[onlyFiled]" class="table-list-radio"  @change="selectMealRow(scope.row)"></el-radio>
                        </template>
                    </el-table-column>
                    <slot name="before"/>
                </template>
                <slot/>
            </wt-table>
        </wt-paged-table>
    </div>
</template>
<script>
export default {
  name: 'pt-radio-list',
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    totalCount: {
      type: Number,
      default: 0
    },
    selectRow: {
      type: [Object, Array],
      default: function () {
        return {}
      }
    },
    pageSize: {
      type: Number,
      default: 5
    },
    // 如果已选择部分显示的字段没有直接在数组的第一层，此字段为显示字段第一层的字段名
    subFiled: {
      type: String,
      default: ''
    },
    // 如果已选择部分显示的字段有多层，此字段为显示字段第二层的字段名
    subSecondFiled: {
      type: String,
      default: ''
    },
    // 包含唯一标识符字段的对象名
    subOnlyFiled: {
      type: String,
      default: ''
    },
    // 列表对象唯一标识符
    onlyFiled: {
      type: String,
      default: 'id'
    }
  },

  data () {
    return {
      totalNumber: this.totalCount,
      selectIndex: null,
      list: this.tableData
    }
  },
  watch: {
    totalCount (val) {
      this.totalNumber = val
    },
    selectRow: {
      handler: function (val) {
        this.selectMealRow(val)
      }
    },
    tableData: {
      handler: function (val) {
        val.forEach((etem, index) => {
          if (typeof this.selectRow === 'object') {
            if (this.subOnlyFiled) {
              if (this.selectRow[this.subOnlyFiled] && etem[this.subOnlyFiled][this.onlyFiled] === this.selectRow[this.subOnlyFiled][this.onlyFiled]) {
                this.selectIndex = this.selectRow[this.subOnlyFiled][this.onlyFiled]
              }
            } else {
              if (this.selectRow && this.selectRow[this.onlyFiled] && etem[this.onlyFiled] === this.selectRow[this.onlyFiled]) {
                this.selectIndex = this.selectRow[this.onlyFiled]
              }
            }
          }
        })
      }
    }
  },
  methods: {
    select () {},
    reset () {
      this.$refs.tablePage.resetPage()
    //   this.selectRow = []
    },
    getTableData (page, next) {
      // 这里加延时，是为了给勾选状态以(动画)过渡时间
      this.$emit('getTableData', page, data => {
        this.list = data
        setTimeout(() => {
          next(data)
        }, 200)
      })
    //   this.$emit('getTableData', page, next)
    },
    selectMealRow (val) {
      this.$emit('selcted', val)
    }
  }
}
</script>
<style module lang="less">

@import "~less/var";
.radio-table-message{
        :global
    .table-list-radio{
         .el-radio__label{
            display: none;
        }
    .el-radio__inner{
        border:1px solid #409eff;
        border-radius:50%
    }
    }

}
</style>
